export const orderOfMagnitudeObject = (num, fixed = 1) => {
  if (num === null) {
    return {};
  }

  if (Math.abs(num) < 1000) {
    return { value: num };
  }

  const b = num.toPrecision(2).split('e'); // get power
  const k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
  const c = k < 1 ? num.toFixed(fixed) : (num / Math.pow(10, k * 3)).toFixed(fixed); // divide by power
  const value = c < 0 ? -Math.abs(c) : Math.abs(c); // enforce -0 is 0

  return {
    value,
    unit: ['', 'K', 'M', 'B', 'T'][k],
  };
};

export const orderOfMagnitude = (num, fixed = 1) => {
  const { value = '', unit = '' } = orderOfMagnitudeObject(num, fixed);

  return `${value}${unit}`;
};

export const getValueFormatter = () => d => (d ? orderOfMagnitude(d, 2) : '');
